<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<h1 class="head">
	Copyright</h1>
<div class="halftitle">
<div class="copy_block">
<p class="center">
			Diversion Books</p>
<p class="center">
			A Division of Diversion Publishing Corp.</p>
<p class="center">
			443 Park Avenue South, Suite 1004</p>
<p class="center">
			New York, NY 10016</p>
<p class="center">
<a href="http://www.diversionbooks.com" target="_blank">www.DiversionBooks.com</a></p>
</div>
<div class="copy_block">
<p class="center">
			Copyright © 1997 by Jane Bonander</p>
</div>
<div class="copy_block">
<p class="center">
			All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
</div>
<div class="copy_block">
<p class="center">
			For more information, email <a href="http://info@diversionbooks.com" target="_blank">info@diversionbooks.com</a>.</p>
<p class="center">
			First Diversion Books edition May 2013.</p>
<p class="center">
			ISBN: 9781626810341</p>
</div>
</div>
<div class="next">
<p class="first" style="padding-top:20%;font-size:1.1em; text-align: justify">
<em>For two of my favorite small-dog lovers, Evelyn Bonander and Donna King, and for Dorothy Lohman, whose Shih Tzu, Tashi, taught me everything I needed to know about the breed.</em></p>
</div>
<div class="next">
<div class="block">
<p class="first" style="padding-top:20%;">
			Let those love now who never loved before;</p>
<p class="first">
			Let those who always loved, now love the more.</p>
<p class="right">
			—Thomas Parnell</p>
</div>
</div>
<div class="next">
<p class="first" style="padding-top:20%;font-size:1.1em;">
<em><span style="text-indent: 1.5em; font-size: 1em; line-height: 1.4;">A special </span></em><em><span style="text-indent: 1.5em; font-size: 1em; line-height: 1.4;">thank-you</span></em><em><span style="text-indent: 1.5em; font-size: 1em; line-height: 1.4;"> to my Michigan friends, Nancy Giggey and Peggy Wang, for their unwavering support and for the title of this book.</span></em></p>
</div>
<p>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap134654.vue?58d58618